module.exports = __webpack_public_path__ + "img/logo.8ef64954.png";